/* ========================================================
   THREEKIT UI LAYOUT & TRANSLATION MAP
   ======================================================== */

window.BUILDER_SECTION_MAP = {
  "Frame & Color": {
    "Color":   ["Uprights_Color"],
    "Crossbar": ["Crossbar", "Front_Foot_Stabilizers_POS_DC"]
  },
  "Cable System": {
    "Weight Stack": [
      "Weight_System",
      "Weight_Stack_Amount",
      "Weight_Stack1_Position",
      "Weight_Stack2_Position"
    ]
  },
  "Smith Machine": {
    "Smith Machine": ["Smith_Machine", "Smith_Position"]
  },
  "Accessories": {
    "Add-ons": [
      "J-Hooks_Type1", "J-Hooks_Type1_Position",
      "J-Hooks_Type4", "J-Hooks_Type4_Position",
      "Spotter_Arms",  "Spotter_Arms_Position",
      "Monkey_Bar",    "Position_WC1"
    ]
  },
  "Storage": {
    "Weight Pins": [
      "Weight_Pins_20cm_Amount",
      "Weight_Pins_30cm_Amount"
    ]
  }
};

/* ========================================================
   TRANSLATION DICTIONARY
   ======================================================== */

window.BUILDER_DICTIONARY = {
  "D1":  "Front",
  "D2":  "Middle",
  "D3":  "Back",
  "DC2": "Front",
  "DC3": "Middle",
  "DC4": "Back",
  "DCL2": "Left Front",
  "DCL3": "Left Middle",
  "DCL4": "Left Back",
  "DCR2": "Right Front",
  "DCR3": "Right Middle",
  "DCR4": "Right Back",
  "42":  "Short (42cm)",
  "78":  "Mid (78cm)",
  "108": "Long (108cm)",
  "0":   "None",
  "Rear_Crossbar_WC":              "Rear Crossbar",
  "Front_Foot_Stabilizers_POS_DC": "Front Foot Stabilizers",
  "Weight_Stack1_Position":        "Left Weight Stack Position",
  "Weight_Stack2_Position":        "Right Weight Stack Position",
  "Weight_Stack_Amount":           "Number of Weight Stacks",
  "Weight_Stack_Position_Combined":"Weight Stack Position",
  "Smith_Machine":  "Smith Machine",
  "Smith_Position": "Smith Position",
  "J-Hooks_Type1":  "J-Hooks Type 1",
  "J-Hooks_Type4":  "J-Hooks Type 4",
  "Spotter_Arms":   "Spotter Arms",
  "Monkey_Bar":     "Pull-Up Bar"
};

/* ========================================================
   WEIGHT STACK COMPOSITE SKU MAP
   Key format: "side_crossbarWidthCm_positionNumber"
   DCL2/DCR2=1, DCL3/DCR3=2, DCL4/DCR4=3
   Placeholder SKU output by Threekit when no composite
   is configured — always stripped and replaced by resolver.
   ======================================================== */

window.WEIGHT_STACK_PLACEHOLDER_SKU = '555-3381';

window.WEIGHT_STACK_SKU_MAP = {
  'left_42_1':   '555-3379',
  'right_42_1':  '555-3380',
  'left_78_1':   '555-3382',
  'left_78_2':   '555-3383',
  'right_78_1':  '555-3384',
  'right_78_2':  '555-3385',
  'left_108_1':  '555-3388',
  'left_108_2':  '555-3389',
  'left_108_3':  '555-3390',
  'right_108_1': '555-3391',
  'right_108_2': '555-3392',
  'right_108_3': '555-3393',
};

/* ========================================================
   CROSSBAR SKU → WIDTH MAP
   ======================================================== */

window.CROSSBAR_SKU_TO_WIDTH = {
  '555-1433': '42',
  '555-1434': '78',
  '555-1439': '78',
  '555-1435': '108',
  '555-1436': '108',
};

/* ========================================================
   HELPER FUNCTIONS
   ======================================================== */

window.translateTKName = function(rawValue) {
  if (!rawValue) return '';
  return window.BUILDER_DICTIONARY[String(rawValue).trim()] || String(rawValue).trim();
};

function getCategoryForAttribute(attrName) {
  for (const [catName, subcats] of Object.entries(window.BUILDER_SECTION_MAP || {})) {
    for (const attrs of Object.values(subcats)) {
      if (attrs.includes(attrName)) return catName;
    }
  }
  return null;
}

function getDependencyHint(attrName) {
  return (window.BUILDER_DEPENDENCY_HINTS || {})[attrName] ||
         'Complete the selections above to enable this option';
}

/* ========================================================
   CHIP ATTRS — always render as capsule chips
   ======================================================== */

window.BUILDER_CHIP_ATTRS = new Set([
  'Crossbar',
  'Weight_Stack_Amount',
  'Smith_Position',
  'Weight_Stack1_Position',
  'Weight_Stack2_Position',
]);

/* ========================================================
   MUTEX PAIRS — selecting one auto-clears the other
   ======================================================== */

window.BUILDER_MUTEX_PAIRS = {
  'J-Hooks_Type1': 'J-Hooks_Type4',
  'J-Hooks_Type4': 'J-Hooks_Type1',
};

/* ========================================================
   ATTR → STATUS.SKUS KEY
   For binary/toggle attrs whose SKU lives in status.skus
   ======================================================== */

window.BUILDER_ATTR_SKU_KEY = {
  // From status.skus console output: SKU_J-Hooks_Type1 and SKU_J-Hooks_Type4
  // are the new specific keys Threekit now propagates
  'J-Hooks_Type1': 'SKU_J-Hooks_Type1',
  'J-Hooks_Type4': 'SKU_J-Hooks_Type4',
  'Spotter_Arms':  'SKU_O_Spotter_Arms',
  'Smith_Machine': 'SKU_H_Smith',
  'Monkey_Bar':    'SKU_Position_WC1',
};

/* ========================================================
   FIXED SKUS — permanent Shopify product SKUs per toggle attr.
   Used as image/price fallback when status.skus returns N/A
   (e.g. J-Hooks_Type4 when Type1 is selected — Threekit
   returns N/A for the inactive partner's key).
   These never change regardless of configuration state.
   ======================================================== */
window.BUILDER_ATTR_FIXED_SKUS = {
  'J-Hooks_Type1': '555-1446',
  'J-Hooks_Type4': '555-1448',
  'Spotter_Arms':  '555-1453',
  'Smith_Machine': '555-1560',
  'Monkey_Bar':    '555-1445',
};

/* ========================================================
   PIN UNIT SKUS — the single-unit SKU for each pin amount attr.
   Used by resolveOptionData to get the correct image and
   per-unit price for tile display (quantity × unit price).
   These are blocked from the general BOM extraction to prevent
   leakage from Threekit's matchingPropagatedData on other attrs.
   ======================================================== */
window.BUILDER_PIN_UNIT_SKUS = {
  'Weight_Pins_20cm_Amount': '555-1451',
  'Weight_Pins_30cm_Amount': '555-1450',
};

/* ========================================================
   HIDDEN ATTRS
   In BUILDER_SECTION_MAP so X-button clears them,
   but never rendered visibly in the UI.
   Note: Smith_Position is NOT hidden — shows greyed until
   Smith Machine is selected, then becomes active.
   ======================================================== */

window.BUILDER_HIDDEN_ATTRS = new Set([
  'Position_WC1',           // monkey bar position — no customer choice
  'J-Hooks_Type1_Position', // position fixed — nothing to choose
  'J-Hooks_Type4_Position', // position fixed — nothing to choose
  'Spotter_Arms_Position',  // position fixed — nothing to choose
  'Rear_Crossbar_WC',       // always reinforced — no customer choice
  'Weight_System',          // internal — controlled by Weight_Stack_Amount
]);

/* ========================================================
   DEPENDENCY HINTS — tooltip for greyed/disabled attrs
   ======================================================== */

window.BUILDER_DEPENDENCY_HINTS = {
  'Weight_Stack1_Position':        'Select number of stacks first',
  'Weight_Stack2_Position':        'Select 2 stacks first',
  'Smith_Position':                'Add Smith Machine first',
  'Front_Foot_Stabilizers_POS_DC': 'Select Short (42cm) crossbar first',
};

/* ========================================================
   COLOR SWATCHES
   ======================================================== */

window.BUILDER_COLOR_SWATCHES = {
  'Black':    '#111111',
  'White':    '#ffffff',
  'Military': '#786e43',
  'Green':    '#5ced4f',
  'Red':      '#ff212c',
  'Steel':    '#808080',
};

/* ========================================================
   SECTION NOTES — shown at bottom of section when condition met
   condition(localUIState) → bool
   ======================================================== */

window.BUILDER_SECTION_NOTES = {
  'Frame & Color': [
    {
      condition: (s) => s.Crossbar && s.Crossbar !== '42',
      text: 'Front Foot Stabilizers are only available with the Short (42cm) crossbar.'
    }
  ],
  'Cable System': [
    {
      // Weight stack not compatible with Smith Machine on 42cm (any position)
      // or 108cm at middle position
      condition: (s) => s.Smith_Machine && s.Smith_Machine !== 'No' && s.Smith_Machine !== null && (
        s.Crossbar === '42' ||
        (s.Crossbar === '108' && (
          s.Weight_Stack1_Position === 'DCL3' || s.Weight_Stack1_Position === 'DCR3' ||
          s.Weight_Stack2_Position === 'DCL3' || s.Weight_Stack2_Position === 'DCR3'
        ))
      ),
      text: 'The Weight Stack is not compatible with the Smith Machine in this configuration. Remove the Smith Machine or change the position first.'
    },
    {
      condition: (s) => s.Weight_Stack_Amount === '1',
      text: 'To choose the Right position, first set the Left position to None.'
    },
    {
      // Middle position conflicts with Smith Machine on 42cm (any position incompatible)
      // and on 108cm specifically at middle position
      condition: (s) => s.Smith_Machine && s.Smith_Machine !== 'No' && s.Smith_Machine !== null && (
        s.Crossbar === '42' ||
        (s.Crossbar === '108' && (
          s.Weight_Stack1_Position === 'DCL3' || s.Weight_Stack1_Position === 'DCR3' ||
          s.Weight_Stack2_Position === 'DCL3' || s.Weight_Stack2_Position === 'DCR3'
        ))
      ),
      text: 'Middle position is not compatible with the Smith Machine on this crossbar. Selecting it will remove the Weight Stacks.'
    },
    {
      // Smith Machine set to Middle position conflicts with Weight Stack on 108cm
      condition: (s) => s.Smith_Position === 'DC3' && s.Smith_Machine && s.Smith_Machine !== 'No' &&
                        s.Crossbar === '108',
      text: 'Smith Machine is set to Middle position — this conflicts with the Weight Stack on the Long (108cm) crossbar. Change Smith Position to Front or Back, or remove the Weight Stack.'
    }
  ],
  'Smith Machine': [
    {
      // Incompatible with cable system on 42cm (any position) or 108cm at middle position
      condition: (s) => s.Weight_System && s.Weight_System !== null && (
        s.Crossbar === '42' ||
        (s.Crossbar === '108' && (
          s.Weight_Stack1_Position === 'DCL3' || s.Weight_Stack1_Position === 'DCR3' ||
          s.Weight_Stack2_Position === 'DCL3' || s.Weight_Stack2_Position === 'DCR3'
        ))
      ),
      text: 'Smith Machine Middle position is not compatible with the 95kg Cable System on the Long (108cm) crossbar.Select Front or Back position to have both items, if Middle is selected it will override the cable system.'
    },
    {
      // Smith Machine Middle position conflicts with Cable System on 108cm
      condition: (s) => s.Smith_Position === 'DC3' && s.Weight_System && s.Weight_System !== null &&
                        s.Crossbar === '108',
      text: 'Smith Machine Middle position is not compatible with the 95kg Cable System on the Long (108cm) crossbar. Select Front or Back position, or if Middle is selected it will override the cable system.'
    }
  ],
  'Storage': [
    {
      condition: (s) => s.Weight_Pins_20cm_Amount === '4',
      text: 'All 4 pin slots are used by the other pins, Those Weight Pins are not available.'
    }
  ],
};